export enum DIALOG_CONTENT_TYPE {
    SIMPLE,
    CHIPS
}